import axios from "axios";
import Config from "../../Config";

class DashboardRequests {
  static baseUrl = `${Config.backendDomain}vendor`;

  async getRecentDeals(numberOfDeals = 3) {
    const response = await axios.get(`${DashboardRequests.baseUrl}/vendorDeals/${numberOfDeals}`,{
      headers:{
        Authorization: `Bearer ${localStorage.getItem("dealboxx_token")}`,
      }
    });
    return response.data;
  }

  async getStatsDealsCampaigns(){
    const response =  await axios.get(`${DashboardRequests.baseUrl}/stats/deals`,{
      headers:{
        Authorization: `Bearer ${localStorage.getItem("dealboxx_token")}`,
      }
    });
    return response.data;
  }
}
const instance = new DashboardRequests();
Object.freeze(instance);

export default instance;
